import 'css-chunksrc/client/pages/projectPage/wbsPage/filters/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_jfy0t_1",
  "input": "_input_jfy0t_7",
  "toggleArrow": "_toggleArrow_jfy0t_23",
  "selectedDataTypes": "_selectedDataTypes_jfy0t_31",
  "placeholder": "_placeholder_jfy0t_40",
  "list": "_list_jfy0t_45",
  "item": "_item_jfy0t_57",
  "typeName": "_typeName_jfy0t_70",
  "opened": "_opened_jfy0t_77"
};